<template>
  <AppLayout>
    <div class="space-y-4 p-4 max-w-7xl mx-auto">
      <!-- Header with Period Info -->
      <div class="bg-white p-4">
        <h1 class="text-2xl font-bold text-center mb-4">Redata Rikastamise Ralli 🏆</h1>
        <div class="flex flex-wrap items-center justify-center gap-4 mb-4">
          <div class="flex items-center gap-2">
            <label class="font-semibold">Alguskuupäev:</label>
            <DatePicker
              v-model="startDate"
              :date-format="'dd.mm.yy'"
              showIcon
              fluid
              iconDisplay="input"
              placeholder="Vali alguskuupäev"
              @date-select="onDateChange"
              class="max-w-40"
            />
          </div>
          <div class="flex items-center gap-2">
            <label class="font-semibold">Lõppkuupäev:</label>
            <DatePicker
              v-model="endDate"
              :date-format="'dd.mm.yy'"
              showIcon
              fluid
              iconDisplay="input"
              placeholder="Vali lõppkuupäev"
              @date-select="onDateChange"
              class="max-w-40"
            />
          </div>
        </div>
        <div class="text-sm text-gray-600 text-center">
          <p>Periood: <strong>{{ formatDate(period.start) }}</strong> kuni <strong>{{ formatDate(period.end) }}</strong></p>
          <p>Osalejaid kokku: <strong>{{ total_participants }}</strong></p>
        </div>
      </div>

      <!-- Leaderboard Table -->
      <div class="bg-white rounded-lg shadow-sm">
        <DataTable :value="leaderboard" tableStyle="min-width: 50rem" striped sortMode="single">
          <Column header-class="bg-gray-100" field="rank" header="Koht" :style="{ width: '80px' }">
            <template #body="{ data }">
              <div class="flex items-center justify-center">
                <span v-if="data.rank === 1" class="text-2xl">🥇</span>
                <span v-else-if="data.rank === 2" class="text-2xl">🥈</span>
                <span v-else-if="data.rank === 3" class="text-2xl">🥉</span>
                <span v-else class="font-semibold">{{ data.rank }}</span>
              </div>
            </template>
          </Column>
          <Column header-class="bg-gray-100" field="user_name" header="Nimi"></Column>
          <Column header-class="bg-gray-100" field="total_unique_transactions" header="Rikastatud tehinguid" sortable :style="{ fontWeight: 'bold' }">
            <template #body="{ data }">
              <span class="font-bold text-lg">{{ data.total_unique_transactions }}</span>
            </template>
          </Column>
          <Column header-class="bg-gray-100" field="total_enrichment_activities" header="Rikastamise liigid kokku" sortable>
            <template #body="{ data }">
              <div class="space-y-1 text-sm">
                <div class="flex justify-between gap-2">
                  <span>Kuulutused:</span>
                  <span class="font-semibold">{{ data.breakdown.kuulutuse_lisamine }}</span>
                </div>
                <div class="flex justify-between gap-2">
                  <span>Ehitise seisukord:</span>
                  <span class="font-semibold">{{ data.breakdown.ehitise_seisukord }}</span>
                </div>
                <div class="flex justify-between gap-2">
                  <span>Hooneosa seisukord:</span>
                  <span class="font-semibold">{{ data.breakdown.hooneosa_seisukord }}</span>
                </div>
                <div class="flex justify-between gap-2">
                  <span>Rõdu:</span>
                  <span class="font-semibold">{{ data.breakdown.rodu }}</span>
                </div>
                <div class="flex justify-between gap-2 mt-2 pt-2 border-t border-gray-300">
                  <span class="font-bold">Kokku:</span>
                  <span class="font-bold text-lg">{{ data.total_enrichment_activities }}</span>
                </div>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { ref, onMounted } from 'vue'
import { useFormatDate } from '@/composables/useFormatDate'
import AppLayout from '../Layouts/AppLayout.vue'

const { formatDate, formatDatePickerToISO, formatISOToDatePicker } = useFormatDate()

const props = defineProps({
  leaderboard: {
    type: Array,
    default: () => [],
  },
  total_participants: {
    type: Number,
    default: 0,
  },
  period: {
    type: Object,
    default: () => ({
      start: '',
      end: '',
    }),
  },
})

// Initialize date pickers with current period
const startDate = ref(null)
const endDate = ref(null)

onMounted(() => {
  if (props.period.start) {
    startDate.value = formatISOToDatePicker(props.period.start)
  }
  if (props.period.end) {
    endDate.value = formatISOToDatePicker(props.period.end)
  }
})

const onDateChange = () => {
  // Only reload if both dates are selected
  if (startDate.value && endDate.value) {
    router.get(
      route('leaderboard'),
      {
        start_date: formatDatePickerToISO(startDate.value),
        end_date: formatDatePickerToISO(endDate.value),
      },
      {
        preserveState: true,
        preserveScroll: true,
      }
    )
  }
}
</script>
